module.exports = __webpack_public_path__ + "static/media/c4bannerModul1_small.740c086f.jpg";